import { DocumentNode } from 'graphql';
import { createContext, useContext } from 'react';

export interface TimelineVariables {
  sectionId?: string;
  eventId?: string;
  templateId?: string;
  favoriteSectionId?: string;
}

export type TimelineSettings = {
  canAnswer: boolean;
};

export interface SectionsGqlMutations {
  moveSongs: GqlMutation;
  moveQuestions: GqlMutation;
  updateSection: GqlMutation;
}

export type SectionsGqlFragments = {
  section: DocumentNode;
};

export type SectionsGql = {
  mutations: SectionsGqlMutations;
  fragments: SectionsGqlFragments;
};

export type SongsGqlMutations = {
  reorder: GqlMutation;
};

export type SongsGql = {
  mutations: SongsGqlMutations;
};

export type EventGqlMutations = {
  update: GqlMutation;
};

export type EventGql = {
  mutations: EventGqlMutations;
};

export type PlaylistsGqlMutations = {
  add: GqlMutation;
  delete: GqlMutation;
  reorder: GqlMutation;
};

export type PlaylistsGqlQueries = {
  user: GqlQuery;
  vibo: GqlQuery;
  company: GqlQuery;
  section: GqlQuery;
  songs: GqlQuery;
};

export type PlaylistsGql = {
  mutations: PlaylistsGqlMutations;
  queries: PlaylistsGqlQueries;
};

export type QuestionsGqlMutations = {
  create: GqlMutation;
  clone: GqlMutation;
  update: GqlMutation;
  answer: GqlMutation;
  reorder: GqlMutation;
  delete: GqlMutation;
  updateBlocks: GqlMutation;
};

export type QuestionsGqlQueries = {
  questions: GqlQuery;
};

export type QuestionsGql = {
  queries: QuestionsGqlQueries;
  mutations: QuestionsGqlMutations;
};

export type AllTimelineGqlOptions = {
  event: EventGql;
  sections: SectionsGql;
  songs: SongsGql;
  playlists: PlaylistsGql;
  questions: QuestionsGql;
};

export type TypeTimelineContext<ExtendOptions = {}> = {
  variables: TimelineVariables;
  settings: TimelineSettings;
} & ExtendOptions;

export const TimelineContext = createContext<TypeTimelineContext>(undefined!);

export const useTimeline = <T extends object = {}>() =>
  useContext(TimelineContext) as TypeTimelineContext & T;
